// src/components/RoutePart.tsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { COLORS } from "../assets/theme";
import AutoComplete from "./common/AutoComplete";
import CustomTextField from "./common/CustomTextField";
import { BulkRateRouteRequest } from "../services/RoutingPlanDetailsService";

interface RoutePartProps {
  request: Partial<BulkRateRouteRequest>;
  setRequest: React.Dispatch<React.SetStateAction<Partial<BulkRateRouteRequest>>>;
  providerOptions?: { label: string; value: string }[];
  fullWidth?: boolean;
}

const RoutePart: React.FC<RoutePartProps> = ({
  request,
  setRequest,
  providerOptions,
  fullWidth,
}) => (
  <Box
    flex={1}
    display="flex"
    flexDirection="column"
    alignItems="center"
    sx={{ width: fullWidth ? "100%" : "auto" }}
  >
    <Typography variant="h6" mb={2}>
      Route
    </Typography>

    <AutoComplete
      label="Route*"
      sx={{
        mb: 2,
        "& .MuiInputBase-root": { backgroundColor: COLORS.WhiteBackground },
      }}
      placeholder="Route"
      options={providerOptions ?? []}
      value={request.providerId ?? ""}
      onChange={(value) =>
        setRequest({ ...request, providerId: String(value) })
      }
    />

    <Typography
      variant="subtitle1"
      mb={1}
      sx={{
        alignSelf: "flex-start",
        textAlign: "left",
        width: "80%",
      }}
    >
      Blending
    </Typography>

    <Box display="flex" gap={1} sx={{ mb: 2, width: "100%" }}>
      <AutoComplete
        sx={{ "& .MuiInputBase-root": { backgroundColor: COLORS.WhiteBackground } }}
        placeholder="Provider 1"
        options={providerOptions ?? []}
        value={request.provider1Id ?? ""}
        onChange={(value) =>
          setRequest({ ...request, provider1Id: String(value) })
        }
      />
      <CustomTextField
        placeholder="Percentage 1"
        bgColor={COLORS.WhiteBackground}
        value={request.percentage1 ?? ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          let numberVal = Number(newValue);
          if (!isNaN(numberVal) && numberVal > 100) {
            numberVal = 100;
          }
          setRequest((prev) => ({
            ...prev,
            percentage1: newValue !== "" ? numberVal : undefined,
          }));
        }}
      />
    </Box>

    <Box display="flex" gap={1} sx={{ mb: 2, width: "100%" }}>
      <AutoComplete
        sx={{ "& .MuiInputBase-root": { backgroundColor: COLORS.WhiteBackground } }}
        placeholder="Provider 2"
        options={providerOptions ?? []}
        value={request.provider2Id ?? ""}
        onChange={(value) =>
          setRequest({ ...request, provider2Id: String(value) })
        }
      />
      <CustomTextField
        placeholder="Percentage 2"
        bgColor={COLORS.WhiteBackground}
        value={request.percentage2 ?? ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          let numberVal = Number(newValue);
          if (!isNaN(numberVal) && numberVal > 100) {
            numberVal = 100;
          }
          setRequest((prev) => ({
            ...prev,
            percentage2: newValue !== "" ? numberVal : undefined,
          }));
        }}
      />
    </Box>

    <Box display="flex" gap={1} sx={{ mb: 2, width: "100%" }}>
      <AutoComplete
        sx={{ "& .MuiInputBase-root": { backgroundColor: COLORS.WhiteBackground } }}
        placeholder="Provider 3"
        options={providerOptions ?? []}
        value={request.provider3Id ?? ""}
        onChange={(value) =>
          setRequest({ ...request, provider3Id: String(value) })
        }
      />
      <CustomTextField
        placeholder="Percentage 3"
        bgColor={COLORS.WhiteBackground}
        value={request.percentage3 ?? ""}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = e.target.value;
          let numberVal = Number(newValue);
          if (!isNaN(numberVal) && numberVal > 100) {
            numberVal = 100;
          }
          setRequest((prev) => ({
            ...prev,
            percentage3: newValue !== "" ? numberVal : undefined,
          }));
        }}
      />
    </Box>
  </Box>
);

export default RoutePart;